import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import type { UserWithDetails } from "../services/userService";
import { userService } from "../services/userService";

export type User = UserWithDetails;

export function getUserDisplayName(userData: User | undefined): string {
	return (
		userData?.details?.firstName ??
		userData?.displayName ??
		userData?.email?.split("@")[0] ??
		"there"
	);
}

export function useUser() {
	const { user: auth0User } = useAuth0();

	return useQuery<User>({
		queryKey: ["user", auth0User?.sub],
		queryFn: () => userService.getUserWithDetails(),
		enabled: !!auth0User,
		retry: 3,
		retryDelay: 1000,
	});
}
